<footer class="app-footer">
  <span class="app-footer__copy">
    Copyright &copy; {{ year }},
    <a class="app-footer__link" [href]="companyUrl" target="_blank" rel="noopener">{{ companyName }}</a>
  </span>

  <nav class="app-footer__links" aria-label="Footer links">
    <a class="app-footer__link" [href]="resourcesUrl">Resources</a>
    <span class="app-footer__divider" aria-hidden="true">|</span>
    <a class="app-footer__link" [href]="legalUrl">Legal</a>
    <span class="app-footer__divider" aria-hidden="true">|</span>
    <a class="app-footer__link" [href]="supportUrl">Support</a>
  </nav>

  <div class="app-footer__session">
    <span class="app-footer__stamp">{{ sessionTag() }}</span>
    <button type="button" class="app-footer__copy-btn"
            [attr.aria-label]="copied() ? 'Copied' : 'Copy session details'"
            (click)="copySessionTag()">
      <i class="pi" [class.pi-copy]="!copied()" [class.pi-check]="copied()" aria-hidden="true"></i>
      <span>{{ copied() ? 'Copied' : 'Copy' }}</span>
    </button>
  </div>
</footer>
